import type { CountryCode } from '@repo/design-system-kit';

export const FATCA_EXCLUDED_LEGAL_FORMS = [
  '1000', // FR - Entrepreneur Individuel a Responsabilité Limitée (EIRL)
  '1100', // FR - Artisan-Commerçant
  '1200', // FR - Commerçant
  '1300', // FR - Artisan
  '1400', // FR - Officier public ou ministériel
  '1500', // FR - Profession libérale
  '1600', // FR - Exploitant agricole
  '1700', // FR - Agent commercial
  '1800', // FR - Associé-gérant
  '1900', // FR - Personne physique
  '2110', // FR - Indivision entre personnes physiques
  '2210', // FR - Société créée de fait entre personnes physiques
  '2220', // FR - Société créée de fait avec personne morale
  '3290', // FR - (Autre) personne morale de droit étranger
  'DE002', // DE - Einzelunternehmer
  'IT001', // IT - Imprenditore individuale
  'IT002', // IT - Libero Professionista/Lavoratore autonomo
  'ESC01', // ES - Empresarios Individual (Autónomo)
  'DI', // IT - Impresa individuale
  'PF', // IT - Persona fisica
  'ATCUST301', // AT - Einzelunternehmer
  'NLCUST208', // NL - Eenmanszaak
  'BECUST201', // BE - Zelfstandige
  'PTCUST183', // PT - Empresário em Nome Individual (ENI)
  'PTCUST184', // PT - Trabalhador Independente
];

export const GERMAN_FREELANCER_COMPANY_TYPES = [
  { value: 'DE002', dropdownLabel: 'Einzelunternehmer' },
  { value: 'DE210', dropdownLabel: 'Freiberufler' },
] as const;

export const LOW_RISK_UBO_POI_NATIONALITY_CODES = new Set<CountryCode>([
  'AX',
  'AD',
  'AQ',
  'AR',
  'AW',
  'AU',
  'AT',
  'JE',
  'BE',
  'BJ',
  'BM',
  'BT',
  'BQ',
  'BV',
  'BR',
  'IO',
  'BN',
  'CV',
  'CA',
  'CL',
  'CX',
  'CC',
  'CO',
  'CG',
  'CK',
  'CW',
  'CZ',
  'DK',
  'DJ',
  'DO',
  'EC',
  'SV',
  'GQ',
  'EE',
  'SZ',
  'ET',
  'FO',
  'FI',
  'FR',
  'GF',
  'PF',
  'TF',
  'GA',
  'DE',
  'GR',
  'GL',
  'GD',
  'GP',
  'GG',
  'GY',
  'VA',
  'HN',
  'HK',
  'HU',
  'IS',
  'ID',
  'IE',
  'IL',
  'IT',
  'JP',
  'KR',
  'XK',
  'LV',
  'LS',
  'LI',
  'LT',
  'LU',
  'MG',
  'MW',
  'MV',
  'MQ',
  'YT',
  'FM',
  'MD',
  'ME',
  'MS',
  'NL',
  'NC',
  'NZ',
  'NF',
  'MP',
  'NO',
  'PG',
  'PY',
  'PE',
  'PN',
  'PL',
  'PT',
  'PR',
  'MK',
  'RE',
  'RO',
  'RW',
  'BL',
  'SH',
  'MF',
  'PM',
  'VC',
  'SM',
  'ST',
  'RS',
  'SX',
  'SK',
  'SI',
  'SB',
  'GS',
  'ES',
  'SR',
  'SJ',
  'SE',
  'CH',
  'TW',
  'TL',
  'TG',
  'TK',
  'TO',
  'TV',
  'GB',
  'UM',
  'US',
  'UY',
  'WF',
  'EH',
  'ZM',
]);
